module["exports"] = [
  "(##) ####-####",
  "+55 (##) ####-####",
  "(##) #####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/phone_number/formats.js
// module id = 1503
// module chunks = 0